'use client'

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';

const RyoshiPlaza = () => {
    const t = useTranslations('RyoshiPlaza');
    return (
        <Section
            id="ryoshiplaza"
            backgroundImage="/images/ryoshi-plaza.avif"
            className="relative flex flex-col min-h-screen items-center justify-center bg-cover"
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Top gradient */}
            <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

            {/* Bottom gradient */}
            <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

            <div className="relative flex flex-col items-center text-center px-3 pt-[5.5rem] pb-24">
                <p className="text-white text-center text-base font-semibold leading-4 tracking-wide decoration-skip-ink-0 lg:w-[60%] mt-2 font-sora uppercase my-8">
                    {t('sub-title')}
                </p>
                <h2 className="text-[55px] font-bold leading-[55px] text-center uppercase decoration-skip-ink-0 font-sora text-white mb-6">
                    {t('title')}
                </h2>
                <p className="text-white text-base leading-6 mt-2 font-normal sm:w-[80%] md:w-[60%] lg:w-[60%] tracking-[0.02em] font-sora">
                    {t('description')}
                </p>
                <p className="text-white text-base leading-6 mt-2 font-normal sm:w-[80%] md:w-[60%] lg:w-[60%] tracking-[0.02em] font-sora">
                    {t('details')}
                </p>
                <div className="flex justify-center items-center my-8 w-full md:w-[60%]">
                    <iframe
                        width="100%"
                        height="auto"
                        src="https://www.youtube.com/embed/IryAUnMYFVQ"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="aspect-video"
                    ></iframe>
                </div>
            </div>
        </Section>
    );
};

export default RyoshiPlaza;